import React from "react"
import { batch } from "@preact/signals-react"

import { mainProvider } from "@signals"
import { BACKEND_APIS } from "@constants"
import { AppProvidersAutocomplete } from "@components"


export default function AppCommonFiltersMainProvidersAutocomplete({ ...props }) {
	return <AppProvidersAutocomplete
		multiple={false}
		label="Main providers"
		placeholder="All main providers"
		value={mainProvider.value}
		onChange={e => batch(() => {
			mainProvider.value = e.target.value
		})}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/providers`}
		limitTags={5}
		{...props}
	/>
}